// Figurio: deler kundens cookie-valg mellem butikken (Shopifys cookiebanner) og
// appen (app.figurio.dk), så ingen skal svare to gange.
//
// To formål, hver sin cookie på hele .figurio.dk ("1" = ja, "0" = nej):
//   figurio_ac  <->  Shopifys "analytics"  (statistik: Google Analytics)
//   figurio_mc  <->  Shopifys "marketing"  (marketing: Meta-pixlen)
// Appen (public/consent.js) skriver og læser dem; her spejles de mod Shopify.
//
// Reglerne gælder for hvert formål for sig og er bevidst forsigtige — et NEJ
// spredes altid, et JA fra appen kan aldrig overskrive et udtrykkeligt nej,
// kunden har givet i Shopify:
//   1. Ingen cookie, Shopify har svar      -> cookien skrives ud fra Shopify.
//   2. Cookie ja/nej, Shopify har ikke svar -> Shopify udfyldes med appens svar.
//   3. Cookie nej, Shopify siger ja         -> Shopify sættes til nej på formålet.
//   4. Cookie ja, Shopify siger nej         -> intet. Nejet står ved magt i butikken,
//                                             og appen har sit eget ja.
//   5. Enige                                -> intet.
// Når Shopify opdateres, bevares de øvrige valg. Formål appen ikke spørger om
// (preferences, sale_of_data) sættes til nej, hvis de ikke er besvaret. Et formål
// ingen af stederne har svar på, sendes slet ikke med — så står det åbent, og
// kunden bliver spurgt om det.
// Hver gang kunden svarer i Shopifys banner, opdateres cookierne med det samme
// (hændelsen visitorConsentCollected), så de altid er det SENESTE valg.
//
// Alt er pakket ind i try: en fejl her må aldrig vælte siden.
(function () {
  var PURPOSES = [
    { key: "analytics", cookie: "figurio_ac", clear: /^_ga($|_)|^_gid$|^_gat/ },
    { key: "marketing", cookie: "figurio_mc", clear: /^_fb[pc]$/ },
  ];
  var DAYS = 180;

  function domainAttr() {
    return /(^|\.)figurio\.dk$/.test(location.hostname) ? ";domain=.figurio.dk" : "";
  }
  function read(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? m[1] : null;
  }
  function write(name, value) {
    document.cookie = name + "=" + value + ";path=/;max-age=" + DAYS * 86400 +
      ";samesite=lax" + (location.protocol === "https:" ? ";secure" : "") + domainAttr();
  }
  // Ved nej fjernes formålets cookies (på hele domænet og kun her).
  function clear(pattern) {
    document.cookie.split("; ").forEach(function (c) {
      var name = c.split("=")[0];
      if (!pattern.test(name)) return;
      var kill = name + "=;path=/;max-age=0";
      document.cookie = kill;
      document.cookie = kill + ";domain=.figurio.dk";
    });
  }
  function yes(v) { return v === "yes"; }
  function answered(v) { return v === "yes" || v === "no"; }

  function sync(cp) {
    var v = cp.currentVisitorConsent() || {};
    var patch = {};
    var changed = false;
    PURPOSES.forEach(function (p) {
      var cookie = read(p.cookie);
      var s = v[p.key];
      if (cookie !== "1" && cookie !== "0") {           // regel 1
        if (answered(s)) write(p.cookie, yes(s) ? "1" : "0");
        return;
      }
      var want = cookie === "1";
      if (!answered(s)) {                               // regel 2
        patch[p.key] = want;
        changed = true;
        if (!want) clear(p.clear);
      } else if (!want && yes(s)) {                     // regel 3
        patch[p.key] = false;
        changed = true;
        clear(p.clear);
      }
      // regel 4 og 5: intet
    });
    if (!changed) return;
    var next = { preferences: yes(v.preferences), sale_of_data: yes(v.sale_of_data) };
    PURPOSES.forEach(function (p) {
      if (p.key in patch) next[p.key] = patch[p.key];
      else if (answered(v[p.key])) next[p.key] = yes(v[p.key]);
    });
    cp.setTrackingConsent(next, function () {});
  }

  function start() {
    try {
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        if (err) return;
        var cp = window.Shopify.customerPrivacy;
        if (!cp) return;
        try { sync(cp); } catch (e) { /* stille */ }
        // Svarer kunden i Shopifys banner, gemmes svaret straks til appen.
        document.addEventListener("visitorConsentCollected", function () {
          try {
            var v = cp.currentVisitorConsent() || {};
            PURPOSES.forEach(function (p) {
              if (!answered(v[p.key])) return;
              write(p.cookie, yes(v[p.key]) ? "1" : "0");
              if (!yes(v[p.key])) clear(p.clear);
            });
          } catch (e) { /* stille */ }
        });
      });
    } catch (e) { /* stille */ }
  }
  start();
})();
